<div class="row">
  <div class="col-12">
    <sb-card [loading]="loading">
      <div card-header></div>
      <div card-header-more>
        <sb-comp-dropdown-select
          *ngPermissions="permissionService.Permission.cull_list"
          [showSubmit]="true"
          [inputData]="playerCulls" [dropDownDatatype]="'PLAYER_CULLS'"
          (selectedDataEmitter)="update($event, 'PLAYER_CULLS')" [showColumnIcon]="false"
          [msOptions]="msLocationPlayerCullOptions" (msOptionsChange)="msRequest('PLAYER_CULLS', $event)"
          [selectedInputData]="filteredPlayerCulls ? filteredPlayerCulls : []">
        </sb-comp-dropdown-select>
      </div>
    </sb-card>
  </div>
  <div class="col-6" *ngPermissions="[permissionService.Permission.ss_nm_reporting]">
    <sb-card [loading]=loading>
      <div card-header>
        {{'lang.statisticOverview.locationReporting' | translate}}
      </div>
      <div card-body>
        <h5>{{'lang.statisticOverview.locationStatus' | translate}}</h5>
        <p>{{'lang.statisticOverview.onlyOneCanApply' | translate}}</p>
        <sb-chart chartType="barChart" #barChart *ngIf="!loading" [chartData]="locationChart"></sb-chart>
      </div>
    </sb-card>
  </div>
  <div class="col-6">
    <sb-card [loading]="loading">
      <div card-fit>
        <sb-cluster-map-legacy [playerCull]="filteredPlayerCulls" [scope]="ScreenScope.OWNED"></sb-cluster-map-legacy>
      </div>
    </sb-card>
  </div>
  <ng-container *ngPermissions="permissionService.Permission.visitor_tracker_visitor_aggregation">
    <div class="col-12">
      <sb-card [loading]="loading">
        <div card-header>

        </div>
        <div card-header-more>
          <sb-comp-chart-control [showPlayerCull]="false" [from]="from" [till]="till"
                                 (dateChange)="setTimeFrame($event)"
                                 (intervalChange)="setInterval($event)">
            <sb-comp-dropdown-select
              *ngPermissions="permissionService.Permission.location_list"
              [inputData]="locations" [dropDownDatatype]="'LOCATIONS'"
              (selectedDataEmitter)="update($event, 'LOCATIONS')" [showColumnIcon]="false"
              [msOptions]="msLocationOptions" (msOptionsChange)="msRequest('LOCATIONS', $event)"
              [selectedInputData]="filteredLocations">
            </sb-comp-dropdown-select>

          </sb-comp-chart-control>
        </div>
      </sb-card>
    </div>
    <div class="col-12">
      <sb-comp-visitor-tracker-chart
        *ngIf="!loading"
        [from]="from" [till]="till" [chartHeight]="300" [resolveInCom]="false"
        [inputData]="timeFrameData"
        [halfHeight]="false">
      </sb-comp-visitor-tracker-chart>
    </div>
  </ng-container>
</div>
